import { createHandler } from 'griffin-paypal/number';

export default function parseAmount(value, metadata) {
  if (value === null || value === '') {
    return value;
  } else {
    const griffin = createHandler(metadata);
    const num = griffin.normalizeNumber(value);
    return isNaN(num) || num <= 0 ? undefined : value;
  }
}
